import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@lib/api";
import { API_ROUTES } from "../constants";
import type { VacancyForm } from "../types/VacancyTypes";

export const QUERY_KEY = "getVacancyForm";

interface GetVacancyFormParams {
  locale?: string;
}

export const useGetVacancyForm = (
  formId: string | undefined,
  params?: GetVacancyFormParams
) => {
  return useQuery({
    queryKey: [QUERY_KEY, formId, params],
    queryFn: async (): Promise<VacancyForm> => {
      if (!formId) {
        throw new Error("Vacancy form id is required");
      }
      const response = await apiClient.get<VacancyForm>(
        API_ROUTES.vacancyForm(formId),
        {
          headers: {
            "Content-Type": "application/json",
          },
          params,
        }
      );
      return response.data;
    },
    enabled: !!formId,
  });
};
